export const LightningIcon = () => {
  return (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="64" height="64" rx="20" fill="#B7E801" />
      <path
        d="M41.85 29.8668H36.7V17.8668C36.7 15.0668 35.1834 14.5002 33.3334 16.6002L32 18.1168L20.7167 30.9502C19.1667 32.7002 19.8167 34.1335 22.15 34.1335H27.3V46.1335C27.3 48.9335 28.8167 49.5002 30.6667 47.4002L32 45.8835L43.2834 33.0502C44.8334 31.3002 44.1834 29.8668 41.85 29.8668Z"
        fill="#4A25D5"
      />
    </svg>
  );
};
